import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";

const DEFAULT_PORTRAIT =
  "https://static.prod-images.emergentagent.com/jobs/a3aca552-a4c9-4845-a67b-55cf3e9b7801/images/90d3d3949f38f9dde3437e1e77603b5a6c73a291c8d08eeeb0f872f393a98061.png";

export default function About() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    api.get("/about").then(({ data }) => setAbout(data)).catch(() => setAbout({}));
  }, []);

  const portrait = about?.portrait_base64
    ? `data:${about.portrait_mime || "image/jpeg"};base64,${about.portrait_base64}`
    : DEFAULT_PORTRAIT;

  const headline = about?.headline || "SREHAN DESHMUKH";
  const body = about?.body || "10-year-old photographer. Lover of bricks, bold light, and impossible worlds.";

  return (
    <div data-testid="about-page" className="bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-14">
        <div className="grid grid-cols-12 gap-6 lg:gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="col-span-12 lg:col-span-7"
          >
            <div className="font-anton uppercase text-xs tracking-[0.3em] mb-4 bg-black text-white inline-block px-2 py-1">
              About / Issue 01
            </div>
            <h1 className="font-anton uppercase text-6xl sm:text-8xl leading-[0.9] tracking-tight">
              {headline.split(" ").map((w, i) => (
                <span key={i} className={i === 1 ? "text-[#FF3B30]" : ""}>
                  {w}{" "}
                </span>
              ))}
            </h1>

            <div className="mt-8 border-l-4 border-black pl-6 max-w-xl">
              <p className="font-outfit text-xl leading-relaxed text-zinc-800 whitespace-pre-line">
                <span className="font-anton uppercase text-5xl float-left mr-2 leading-none text-[#FF3B30]">
                  {body.charAt(0)}
                </span>
                {body.slice(1)}
              </p>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
              <div className="border-2 border-black p-4 brutal-shadow-yellow bg-white">
                <div className="font-anton text-4xl">10</div>
                <div className="font-outfit text-xs uppercase tracking-wide text-zinc-600">Years Old</div>
              </div>
              <div className="border-2 border-black p-4 brutal-shadow-red bg-white">
                <div className="font-anton text-4xl">∞</div>
                <div className="font-outfit text-xs uppercase tracking-wide text-zinc-600">Bricks</div>
              </div>
              <div className="border-2 border-black p-4 brutal-shadow-blue bg-white">
                <div className="font-anton text-4xl">1</div>
                <div className="font-outfit text-xs uppercase tracking-wide text-zinc-600">Camera</div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="col-span-12 lg:col-span-5"
          >
            <div className="relative">
              <div className="absolute -top-3 -left-3 w-full h-full bg-[#FFD600] -z-0" />
              <img
                src={portrait}
                alt=""
                data-testid="about-portrait"
                className="relative z-10 w-full h-[420px] sm:h-[540px] object-cover border-4 border-black"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
